import React from 'react';
import { Table } from '@material-ui/core';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import StatusBar from './StatusBar';

export type PrintSectionProps = {
  reportHeader: React.ReactNode;
  columns: unknown[];
  rowData: unknown[];
  kpiData?: string[];
  tableClassName?: string;
};

const PrintSection = ({
  reportHeader,
  columns,
  rowData,
  kpiData,
  tableClassName,
}: PrintSectionProps) => (
  <>
    {reportHeader}
    <Table className={tableClassName}>
      <TableHeader columns={columns} />
      <TableBody columns={columns} rowData={rowData} />
    </Table>
    {(kpiData?.length ?? 0) > 0 && <StatusBar kpiData={kpiData} />}
  </>
);

export default PrintSection;
